module.exports = __webpack_public_path__ + "static/media/megasearch.a75bd583.png";